import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Check, CircleAlert } from "lucide-react";
import React from "react";

export enum VerificationStatus {
    PENDING = "Pending",
    IN_PROGRESS = "In Progress",
    VERIFIED = "Verified",
    DISCREPANCY = "Discrepancy"
}

export enum Priority {
    HIGH = "High",
    MEDIUM = "Medium",
    LOW = "Low"
}

export interface InventoryItemData {
    name: string;
    location: string;
    system_qty: number;
    counted_qty: number | null;
    variance: number;
    status: VerificationStatus;
    priority: Priority;
    last_counted: string;
}

interface InventoryItemCardProps extends InventoryItemData {}

const InventoryItemCard: React.FC<InventoryItemCardProps> = ({
    name,
    location,
    system_qty,
    counted_qty,
    variance,
    status}) => {

    const getVarianceColor = () => {
        if (variance === 0) return "text-green-600";
        if (variance > 0) return "text-blue-600";
        return "text-red-600";
    };

    const getVariancePrefix = () => {
        if (variance === 0) return "";
        if (variance > 0) return "+";
        return "";
    };

    return (
        <Card className="w-full border rounded-lg">
            <CardContent className="flex flex-row items-center justify-between p-4">
                <div className="flex flex-col items-start justify-center gap-y-1 w-[300px]">
                    <span className="font-medium text-lg">{name}</span>
                    <span className="font-normal text-gray-400 text-sm">Location: {location}</span>
                </div>
                <div className="flex flex-col items-center justify-center gap-y-1 w-[150px]">
                    <span className="text-xs text-gray-400">System Qty</span>
                    <span className="font-medium text-lg">{system_qty}</span>
                </div>
                
                <div className="flex flex-row items-center justify-center gap-x-2 w-[350px]">
                    <div className="flex flex-col items-start justify-center gap-y-1">
                        <span className="text-xs text-gray-400">Counted Qty</span>
                        <Input value={counted_qty?.toString()} />
                    </div>
                    <div className="flex flex-col items-center justify-center gap-y-1">
                        <span className="text-xs text-gray-400">Variance</span>
                        <span className={`font-medium ${getVarianceColor()}`}>
                            {getVariancePrefix()}{variance}
                        </span>
                    </div>
                </div>
                
                <div className="flex flex-col items-end justify-end gap-y-2 w-[200px]">
                    {status === VerificationStatus.DISCREPANCY ?
                        <Badge className="bg-red-600 text-white font-normal w-full rounded-[10px] flex flex-row items-center justify-center"> <CircleAlert className="mr-2 w-4" />Discrepancy</Badge> : <Badge className="bg-green-100 text-green-700 font-normal w-full rounded-[10px] flex flex-row items-center justify-center"><Check className="w-4 mr-2" /> Verified</Badge>}
                </div>
            </CardContent>
        </Card>
    );
};

export default InventoryItemCard;
